<template>
    <b-card no-body>

        <b-modal id="create-or-update" size="lg" :title="editing ? 'Yük Güncelle' : 'Yük Oluştur'" no-close-on-esc no-close-on-backdrop>
            <product-create-or-update :editing="editing" v-model="product" :errors="errors"></product-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :add-callback="createNew"
                    name="product"
                    :fields="fields"
                    :buttons="buttons"
                    pagination="server"
                    search></v-table>
                    
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import ShipableProductApi from '@/api/shipable-product'
import ProductCreateOrUpdate from './components/ProductCreateOrUpdate.vue'

export default {
    components:{
        BCard,
        ProductCreateOrUpdate
    },
    data(){
        return{
            editing:false,
            errors:{},
            loading:false,
            product:{
                Id:0,
                Name:null,
                ShipableProductSubGroupId:0,
                Description:null,
                MeasurementUnitId:0,
                Height:null,
                Length:null,
                Width:null,
                Diameter:null,
                ShipableProductValueClassId:null,
                ShipableProductDangerClassId:null,
                ShipableProductFormIds:[]

            },
            fields:[
                { name:"Yük Ana Grubu",key:"ShipableProductMainGroupName", thClass:"w-24",sortable:true,sortKey:'ShipableProductSubGroup.ShipableProductMainGroup.Name'},
                { name:"Yük Alt Grubu",key:"ShipableProductSubGroupName", thClass:"w-24",sortable:true,sortKey:'ShipableProductSubGroup.Name'},
                { name:"Yük",key:"Name", thClass:"w-24",sortable:true,},
                { name:"Yük Değer Sınıflandırması",key:"ShipableProductValueClassName", thClass:"w-14",sortable:true,sortKey:'ShipableProductValueClass.Name'},
                { name:"Yük Tehlike Sınıflandırması",key:"ShipableProductDangerClassName", thClass:"w-14",sortable:true,sortKey:'ShipableProductDangerClass.Name'}
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ]
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.product.Id = 0
            this.product.Name = null
            this.product.ShipableProductSubGroupId = 0
            this.product.Description=null,
            this.product.MeasurementUnitId=0,
            this.product.Height=null,
            this.product.Length=null,
            this.product.Width=null,
            this.product.Diameter=null,
            this.product.ShipableProductValueClassId=null,
            this.product.ShipableProductDangerClassId=null,
            this.product.ShipableProductFormIds=[]
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.$refs.table.rowLoading(true)
            ShipableProductApi.Product.GetById(item.Id)
            .then(res=>{
                if(res.data.Success) {
                    this.product.Id = res.data.Data.Id
                    this.product.Name = res.data.Data.Name                        
                    this.product.ShipableProductSubGroupId = res.data.Data.ShipableProductSubGroupId                        
                    this.product.Description = res.data.Data.Description                        
                    this.product.MeasurementUnitId = res.data.Data.MeasurementUnitId                        
                    this.product.Height = res.data.Data.Height                        
                    this.product.Length = res.data.Data.Length                        
                    this.product.Width = res.data.Data.Width                        
                    this.product.Diameter = res.data.Data.Diameter                        
                    this.product.ShipableProductValueClassId = res.data.Data.ShipableProductValueClassId                        
                    this.product.ShipableProductDangerClassId = res.data.Data.ShipableProductDangerClassId                        
                    this.product.ShipableProductFormIds = res.data.Data.ShipableProductFormIds                        
                    this.$showModal('create-or-update')
                    this.$refs.table.rowLoading(false)
                }
                this.loading = false
            })
        },
        createOrUpdate(){
            this.loading = true
            ShipableProductApi.Product.CreateOrUpdate(this.editing,this.product)
            .then(res=>{
                if(res.data.Success) {
                    this.$refs.table.refresh()
                    this.clearForm()
                    this.$hideModal('create-or-update')
                }
                this.$result(res)
                this.loading = false
            })
        },
        provider(data){
            return ShipableProductApi.Product.Table(data)
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} taşınabilir ürününü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    ShipableProductApi.Product.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>